import { ColumnType } from "@/queries/smart-tables/types";

export const isTextColumnType = (columnType?: ColumnType | string | null): boolean =>
  columnType === undefined || columnType === null || columnType === ColumnType.TEXT;

export const isTraceColumnType = (columnType?: ColumnType | string | null): boolean =>
  columnType === ColumnType.TRACE;

export const isRequestColumnType = (columnType?: ColumnType | string | null): boolean =>
  columnType === ColumnType.REQUEST;

/** Import/system-managed anchors: selectable as sources, never edited. */
export const isReadonlyAnchorColumnType = (columnType?: ColumnType | string | null): boolean =>
  isTraceColumnType(columnType) || isRequestColumnType(columnType);

/** Server-provided metadata child key; avoid hardcoding known metric names. */
export const isExecutionMetadataMetricKey = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

export const isEditableInputColumnType = (columnType?: ColumnType | string | null): boolean =>
  isTextColumnType(columnType) || columnType === ColumnType.HUMAN;

/** Columns that never show stale/running/failed computation UI. */
export const isStableDisplayColumnType = (columnType?: ColumnType | string | null): boolean =>
  isEditableInputColumnType(columnType) || isReadonlyAnchorColumnType(columnType);

/** Plain-text editable columns (inline + dialog), excluding human-input widgets. */
export const isPlainTextEditableColumnType = (columnType?: ColumnType | string | null): boolean =>
  isTextColumnType(columnType);

export const isRunnableColumnType = (columnType?: ColumnType | string | null): boolean =>
  typeof columnType === "string" &&
  columnType.length > 0 &&
  columnType !== ColumnType.TEXT &&
  columnType !== ColumnType.HUMAN &&
  columnType !== ColumnType.COMPOSITION &&
  columnType !== ColumnType.TRACE &&
  columnType !== ColumnType.REQUEST;

/** Freeze Prompt Template → Request and Workflow → Trace; other smart columns → Text. */
export const getSmartColumnStaticConversionTarget = (
  columnType?: ColumnType | string | null,
): ColumnType => {
  if (columnType === ColumnType.PROMPT_TEMPLATE) {
    return ColumnType.REQUEST;
  }
  if (columnType === ColumnType.WORKFLOW) {
    return ColumnType.TRACE;
  }
  return ColumnType.TEXT;
};
